import { Box, Flex } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import config from 'src/config/index';
import { useDashboardDaysStore } from 'src/models/useDashboardDaysModel';

import DashboardLayout from '../../Layout/DashboardLayout';
import TimeRangeSelector from '../../TimeRangeSelector';
import DownloadBlockList from './DownloadBlockList';
import VirtualAnalyzerAffectedByFile from './VirtualAnalyzerAffectedByFile';
import VirtualAnalyzerAffectedByURL from './VirtualAnalyzerAffectedByURL';
import VirtualAnalyzerFrequentFile from './VirtualAnalyzerFrequentFile';
import VirtualAnalyzerFrequentURL from './VirtualAnalyzerFrequentURL';
import VirtualAnalyzerProcessedThreats from './VirtualAnalyzerProcessedThreats';
import VirtualAnalyzerRiskSummary from './VirtualAnalyzerRiskSummary';
import VirtualAnalyzerSuspiciousObjects from './VirtualAnalyzerSuspiciousObjects';
import { useGlobalSettingStore } from '../../../../models/useGlobalSettingModel';
import { useExpandSection } from '../useExpandSection';
import { DashboardPeriod } from '@Types/dashboard';

export default function VirtualAnalyzer() {
  const { t } = useTranslation();
  const daysModel = useDashboardDaysStore();
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const { data, isExpanded, isLoading, onExpandChange, isError, refetch } =
    useExpandSection({
      section: 'virtualAnalyzer',
      period: daysModel.days.DashboardVirtualAnalyzer as DashboardPeriod,
    });

  return (
    <DashboardLayout
      title={t('dashboard.sideBar.virtualAnalyzer')}
      barColor="#00A584"
      titleBar={
        config.ui.hideFeature.dashboard.exportVirtualAnalyzerABlockList ? (
          <TimeRangeSelector widgetId="DashboardVirtualAnalyzer" />
        ) : (
          <Flex direction="row">
            <DownloadBlockList />
            <Box width="20px" />
            <TimeRangeSelector widgetId="DashboardVirtualAnalyzer" />
          </Flex>
        )
      }
      expanded={isExpanded}
      onExpandChange={onExpandChange}
      loading={isLoading}
      loadingFailed={isError}
      onRetryLoading={refetch}
    >
      <VirtualAnalyzerProcessedThreats
        data={data}
        day={daysModel.days['DashboardVirtualAnalyzer']}
      />
      <VirtualAnalyzerRiskSummary
        data={data}
        day={daysModel.days['DashboardVirtualAnalyzer']}
      />
      <VirtualAnalyzerAffectedByFile
        data={data}
        day={daysModel.days['DashboardVirtualAnalyzer']}
      />
      <VirtualAnalyzerSuspiciousObjects
        data={data}
        day={daysModel.days['DashboardVirtualAnalyzer']}
      />
      {selectedOrgGlobalSetting.urlSandboxFeatureShow && (
        <>
          <VirtualAnalyzerAffectedByURL
            data={data}
            day={daysModel.days['DashboardVirtualAnalyzer']}
          />
          <VirtualAnalyzerFrequentURL
            data={data}
            day={daysModel.days['DashboardVirtualAnalyzer']}
          />
        </>
      )}
      <VirtualAnalyzerFrequentFile
        data={data}
        day={daysModel.days['DashboardVirtualAnalyzer']}
      />
    </DashboardLayout>
  );
}
